export default function feedbackarticles(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT':
            return {
                ...state,
                feedbackarticle: action.feedbackarticle,
            }
        default:
            return state;
    }
}
